// ui/surveyForm.ts — client half of the survey form.
//
// Extracted verbatim from an inline <script> in index.html. Posts to
// /api/survey, handled by worker/survey.ts. The checkbox values here must
// stay in step with ALLOWED_FEATURES on the server.

export {};

(function () {
  var boxes   = document.querySelectorAll<HTMLInputElement>('#survey-section input[type=checkbox]');
  var otherEl = document.getElementById('survey-other') as HTMLTextAreaElement | null;
  var emailEl = document.getElementById('survey-email') as HTMLInputElement | null;
  var hpEl    = document.getElementById('survey-website') as HTMLInputElement | null;
  var btn     = document.getElementById('btn-survey') as HTMLButtonElement | null;
  var out     = document.getElementById('survey-result');
  if (!btn || !out) return;

  function show(msg, isErr) {
    out.textContent = msg;
    out.className = 'submit-result' + (isErr ? ' err' : '');
    out.style.marginTop = '8px';
  }
  function validEmail(s) {
    return s.length >= 3 && s.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  }

  async function submit() {
    var features = [];
    boxes.forEach(function (b) { if (b.checked) features.push(b.value); });
    var other = otherEl ? otherEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';

    if (features.length === 0 && !other) {
      show(I18N.t('err_tick'), true);
      return;
    }
    if (email && !validEmail(email)) {
      show(I18N.t('err_email'), true);
      return;
    }

    var handleEl = document.getElementById('handle') as HTMLInputElement | null;
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = I18N.t('sending');

    try {
      var res = await fetch('./api/survey', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          features: features,
          other:    other || null,
          email:    email || null,
          handle:   handleEl ? handleEl.value.trim() || null : null,
          source:   'game',
          website:  hpEl ? hpEl.value : ''
        })
      });
      if (res.ok) {
        show(email ? I18N.t('thanks_email') : I18N.t('thanks'), false);
        boxes.forEach(function (b) { b.disabled = true; });
        if (otherEl) otherEl.disabled = true;
        if (emailEl) emailEl.disabled = true;
        btn.style.display = 'none';
      } else {
        // Shape is whatever the API sent; a non-JSON body leaves it empty
        // and the check below falls through to the generic message.
        var data: any = {};
        try { data = await res.json(); } catch (e) {}
        show(data.error === 'rate limit exceeded'
          ? I18N.t('err_rate')
          : I18N.t('err_save'), true);
        btn.disabled = false;
        btn.textContent = prev;
      }
    } catch (e) {
      show(I18N.t('err_network'), true);
      btn.disabled = false;
      btn.textContent = prev;
    }
  }

  btn.addEventListener('click', submit);
})();
